import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosHandler } from "../lib/utils";
import { useSelector } from "react-redux";

const key = "events";

export const useGetPaginatedEvents = ({
  page = 1,
  limit = 30,
  search = null,
  order,
  filters = {},
}) => {
  let url = `/admin/events/paginated?page=${page}&limit=${limit}&order=${JSON.stringify(
    order
  )}`;
  if (search) url += `&search=${search}`;
  if (filters) url += `&filters=${JSON.stringify(filters)}`;

  const state = useSelector((state) => state);

  const query = useQuery({
    queryKey: [
      key,
      page,
      limit,
      search,
      JSON.stringify(order),
      JSON.stringify(filters),
    ],
    queryFn: async () =>
      await axiosHandler({
        url,
        method: "GET",
        state,
      }),
  });

  return query;
};

export const useDeleteEvent = ({ onSuccess }) => {
  const queryClient = useQueryClient();
  const state = useSelector((state) => state);

  const mutation = useMutation({
    mutationFn: async (id) =>
      await axiosHandler({
        url: `admin/events/${id}`,
        method: "DELETE",
        state,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(key);
      onSuccess?.();
    },
    onError: () => {
      queryClient.invalidateQueries(key);
    },
  });

  return mutation;
};
